import useComputed from '@/hooks/use-computed';
import { immerable } from "immer";
import { useState } from 'react';
import api from '@/services/api/dataExchangeRelation.js';
import orgAPI from '@/services/api/org.js';
import dataElementAPI from '@/services/api/dataElements.js';
import pitstopsAPI from '@/services/api/sys.js';

class DataExchange {
	[immerable] = true
	constructor(params) {
		this.dataExchangeRelationshipId = params.dataExchangeRelationshipId
		this.dataExchangeRelationshipInvitesId = params.dataExchangeRelationshipInvitesId
		this.dataElementId = params.dataElementId
		this.dataElementName = params.dataElementName
		this.senderOrgId = params.senderOrgId
		this.senderOrgName = params.senderOrgName
		this.senderEmail = params.senderEmail
		this.serviceProviderRelationshipId = params.serviceProviderRelationshipId
		this.serviceProviderRelationshipInvitesId = params.serviceProviderRelationshipInvitesId
		this.serviceProviderOrgId = params.serviceProviderOrgId
		this.serviceProviderOrgName = params.serviceProviderOrgName
		this.serviceProviderEmail = params.serviceProviderEmail
		this.serviceProviderRelationshipStatus = params.serviceProviderRelationshipStatus
		this.receiverOrgId = params.receiverOrgId
		this.receiverOrgName = params.receiverOrgName
		this.receiverEmail = params.receiverEmail
		this.modified = params.modified
		this.dataExchangeRelationshipStatus = params.dataExchangeRelationshipStatus
		this.initiater = params.initiater
		this.flow = params.flow
		this.ownSystems = params.ownSystems
		this.$selected = false
		this.pitstopId = params.pitstopId
	}
}

export const modifyResponse =(response) =>{
	const modifiedResponse = response.flatMap((record) => {
		if (record?.ownSystems?.length > 0) {
			return record?.ownSystems?.map((system) => ({
				...record,
				pitstopId: system,
			}));
		} else {
			return {
				...record,
				pitstopId: '',
			};
		}
	});
	return modifiedResponse
}

const useRelationshipSetup = () => {

	const [dataExchangeListing, setDataExchangeListing] = useComputed([])
	const [allOrgData, setAllOrgData] = useState([]);
	const [serviceProviderRelation, setServiceProviderRelation] = useState([]);
	const [dataElement, setDataElement] = useState([]);
	const [pitstops, setPitstops] = useState([]);

	const [dataExchangeLoading, setDataExchangeLoading] = useState(false)
	const [orgDataLoading, setOrgDataLoading] = useState(false)
	const [serviceProviderRelationLoading, setServiceProviderRelationLoading] = useState(false)
	const [dataElementLoading, setDataElementLoading] = useState(false)
	const [pitstopsLoading, setPitstopsLoading] = useState(false)

	const [error, setError] = useState();


	async function fetchDataExchange() {
		setDataExchangeLoading(true);
		const [error, response] = await api.index();

		setDataExchangeLoading(false)

		if (error) {
			return setError('Data Exchange API has error')
		}

		const modifiedResponse=	modifyResponse(response)

		const serializedData = modifiedResponse?.map(entry => serialize(entry))
		const newItems = serializedData.map(params => new DataExchange(params))

		setDataExchangeListing(newItems);
		return newItems;
	}

	async function fetchOrgData() {
		setOrgDataLoading(true)
		const [error, data] = await orgAPI.index();

		setOrgDataLoading(false)
		if (error) {
			return setError('Org API has error')
		}

		if (!Array.isArray(data.items)) {
			return setError('Org API is not an array')
		}

		setAllOrgData(data.items);
	}

	async function fetchServiceProviderRelation() {
		setServiceProviderRelationLoading(true)
		const [error, response] = await api.getServiceProviderRelationships();
		setServiceProviderRelationLoading(false)

		if (error) {
			return setError('Solution Provider Relationship API has error')
		}

		setServiceProviderRelation(response);
	}

	async function fetchDataElements() {
		setDataElementLoading(true);
		const [error, response] = await dataElementAPI.index();
		setDataElementLoading(false)

		if (error) {
			return setError('Data Elements API has error')
		}

		setDataElement(response);
	}

	async function fetchPitstops() {
		setPitstopsLoading(true)
		const [error, data] = await pitstopsAPI.getPitstops()
		setPitstopsLoading(false)

		if (error) {
			return setError('Pitstops API has error')
		}

		setPitstops(data);
	}

	function serialize(entry) {
		return {
			dataExchangeRelationshipId: entry.dataExchangeRelationshipId,
			dataExchangeRelationshipInvitesId: entry.dataExchangeRelationshipInvitesId,
			dataElementId: entry.dataElementId,
			dataElementName: entry.dataElementName,
			senderOrgId: entry.senderOrgId,
			senderOrgName: entry.senderOrgName,
			senderEmail: entry.senderEmail,
			serviceProviderRelationshipId: entry.serviceProviderRelationshipId,
			serviceProviderRelationshipInvitesId: entry.serviceProviderRelationshipInvitesId,
			serviceProviderOrgId: entry.serviceProviderOrgId,
			serviceProviderOrgName: entry.serviceProviderOrgName,
			serviceProviderRelationshipStatus: entry.serviceProviderRelationshipStatus,
			serviceProviderEmail: entry.serviceProviderEmail,
			receiverOrgId: entry.receiverOrgId,
			receiverOrgName: entry.receiverOrgName,
			receiverEmail: entry.receiverEmail,
			modified: entry.modified,
			dataExchangeRelationshipStatus: entry.dataExchangeRelationshipStatus,
			initiater: entry.initiater,
			flow: entry.flow,
			ownSystems: entry.ownSystems,
			pitstopId: entry.pitstopId
		}
	}

	return {
		dataExchangeListing,
		allOrgData,
		serviceProviderRelation,
		dataElement,
		pitstops,
		modifyResponse,
		fetchDataExchange,
		fetchServiceProviderRelation,
		fetchOrgData,
		fetchDataElements,
		fetchPitstops,
		dataExchangeLoading,
		orgDataLoading,
		serviceProviderRelationLoading,
		dataElementLoading,
		pitstopsLoading,
		error
	}

}

export default useRelationshipSetup;
